import type { ITabHeader } from '../Tab.helpers';
import TabHeaderBlock from './Header.Block';
import TabHeaderDefault from './Header.Default';
import TabHeaderPills from './Header.Pills';

const TabHeader = <T extends string>(props: ITabHeader<T>) => {
	if (props.type === 'pills') {
		return <TabHeaderPills {...props} />;
	}

	if (props.type === 'block') {
		return <TabHeaderBlock {...props} />;
	}

	return <TabHeaderDefault {...props} />;
};

export default TabHeader;
